// Bot detection patterns for identifying crawlers and bots
const BOT_PATTERNS = [
  // Search Engines
  { pattern: /Googlebot/i, name: "Googlebot" },
  { pattern: /bingbot/i, name: "Bingbot" },
  { pattern: /Baiduspider/i, name: "Baidu" },
  { pattern: /YandexBot/i, name: "Yandex" },
  { pattern: /DuckDuckBot/i, name: "DuckDuckGo" },
  { pattern: /Slurp/i, name: "Yahoo" },
  
  // SEO Tools
  { pattern: /AhrefsBot/i, name: "Ahrefs" },
  { pattern: /SemrushBot/i, name: "SEMrush" },
  { pattern: /MJ12bot/i, name: "Majestic" },
  { pattern: /DotBot/i, name: "Moz" },
  { pattern: /Screaming Frog/i, name: "Screaming Frog" },
  
  // AI Crawlers
  { pattern: /GPTBot/i, name: "GPTBot" },
  { pattern: /Claude-Web/i, name: "Claude" },
  { pattern: /Anthropic/i, name: "Anthropic" },
  { pattern: /ChatGPT/i, name: "ChatGPT" },
  { pattern: /PerplexityBot/i, name: "Perplexity" },
  
  // Social Media
  { pattern: /facebookexternalhit/i, name: "Facebook" },
  { pattern: /Twitterbot/i, name: "Twitter" },
  { pattern: /LinkedInBot/i, name: "LinkedIn" },
  { pattern: /WhatsApp/i, name: "WhatsApp" },
  { pattern: /TelegramBot/i, name: "Telegram" },
  
  // Monitoring
  { pattern: /UptimeRobot/i, name: "UptimeRobot" },
  { pattern: /Pingdom/i, name: "Pingdom" },
  { pattern: /StatusCake/i, name: "StatusCake" },
  { pattern: /Site24x7/i, name: "Site24x7" },
  
  // Generic (keep last)
  { pattern: /bot|crawler|spider|scraper/i, name: "Bot" },
];

export interface BotDetectionResult {
  isBot: boolean;
  botName: string | null;
}

export function detectBot(userAgent: string): BotDetectionResult {
  if (!userAgent) {
    return { isBot: false, botName: null };
  }
  
  for (const { pattern, name } of BOT_PATTERNS) {
    if (pattern.test(userAgent)) {
      return { isBot: true, botName: name };
    }
  }
  
  return { isBot: false, botName: null };
}

// Country lookup via IP geolocation
export async function getVisitorCountry(): Promise<string | null> {
  try {
    const res = await fetch("https://ipapi.co/country/", {
      signal: AbortSignal.timeout(3000),
    });
    if (res.ok) {
      const country = await res.text();
      return country.trim() || null;
    }
    return null;
  } catch {
    return null;
  }
}

// Country flag emoji from country code
export function getCountryFlag(countryCode: string | null): string {
  if (!countryCode || countryCode.length !== 2) return "🌍";
  
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  
  return String.fromCodePoint(...codePoints);
}
// Re-export formatRelativeTime from centralized formatters
export { formatRelativeTime } from "@/utils/formatters";
